import { creditAssessment, } from "@wayke-se/ecom";
export default (inquiry, callback) => {
    try {
        creditAssessment
            .newCase(inquiry)
            .then((response) => {
            callback(response);
        })
            .catch(callback);
    }
    catch (err) {
        if (err instanceof TypeError) {
            callback(err);
        }
    }
};
